// import { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";

// // Dummy illustration URLs
// const illustrations = {
//   shipping:
//     "https://dummyimage.com/400x250/22c55e/000.png&text=Shipping+Automation",
//   logistics: "https://dummyimage.com/400x250/16a34a/000.png&text=Logistics+ERP",
//   retail: "https://dummyimage.com/400x250/15803d/000.png&text=Retail+ERP",
//   finance:
//     "https://dummyimage.com/400x250/0f766e/000.png&text=Finance+Solutionss",
// };

// const services = [
//   {
//     title: "Shipping & Port Automation",
//     description:
//       "Smart port and vessel management systems that enhance efficiency, transparency, and global trade performance.",
//     icon: "⚓",
//     illustration: illustrations.shipping,
//     features: [
//       "Vessel scheduling & berth allocation",
//       "Cargo handling automation",
//       "Real-time container tracking",
//       "Customs & compliance integration",
//     ],
//   },
//   {
//     title: "Logistics ERP Development",
//     description:
//       "Custom ERP platforms built for freight forwarders, logistics companies, and fleet operators.",
//     icon: "🚛",
//     illustration: illustrations.logistics,
//     features: [
//       "End-to-end logistics workflows",
//       "Warehouse & fleet management",
//       "Integrated invoicing & finance",
//       "Multi-branch, multi-user systems",
//     ],
//   },
//   {
//     title: "Retail & Manufacturing Software",
//     description:
//       "Automation and ERP systems designed to scale retail chains, manufacturing units, and distribution hubs.",
//     icon: "🏭",
//     illustration: illustrations.retail,
//     features: [
//       "Inventory & supply chain visibility",
//       "Barcode & RFID integration",
//       "Production planning",
//       "Demand forecasting",
//     ],
//   },
//   {
//     title: "Finance & Compliance Solutionss",
//     description:
//       "Secure, compliant-ready platforms designed for BFSI, fintech, and regulation-heavy enterprises.",
//     icon: "💹",
//     illustration: illustrations.finance,
//     features: [
//       "Automated reporting & auditing",
//       "Risk & fraud detection",
//       "RBI & DPDP compliance",
//       "Multi-currency support",
//     ],
//   },
// ];

// const industries = [
//   {
//     name: "Shipping & Logistics",
//     icon: "🚢",
//     desc: "Digitizing global trade and cargo operations.",
//   },
//   {
//     name: "Retail",
//     icon: "🛒",
//     desc: "Empowering supply chains and retail networks.",
//   },
//   {
//     name: "Finance",
//     icon: "🏦",
//     desc: "Building secure & compliant BFSI platforms.",
//   },
//   {
//     name: "Manufacturing",
//     icon: "⚙️",
//     desc: "Automation-first approach for factories.",
//   },
// ];

// const whyChoose = [
//   {
//     title: "Domain Expertise",
//     desc: "Deep industry knowledge in shipping, logistics, and finance.",
//   },
//   {
//     title: "Custom Solutionss",
//     desc: "Every system is tailor-made to fit business needs.",
//   },
//   {
//     title: "Cutting-edge Tech",
//     desc: "Modern stacks with AI, cloud, and IoT integration.",
//   },
//   {
//     title: "Global Reach",
//     desc: "Trusted by enterprises across Asia, Africa, and Europe.",
//   },
// ];

// const processSteps = [
//   {
//     step: "1",
//     title: "Consultation",
//     desc: "Understanding client challenges and goals.",
//   },
//   {
//     step: "2",
//     title: "Design & Strategy",
//     desc: "Blueprinting scalable and modern Solutionss.",
//   },
//   {
//     step: "3",
//     title: "Development",
//     desc: "Agile, iterative, and transparent build process.",
//   },
//   {
//     step: "4",
//     title: "Deployment",
//     desc: "Seamless integration and migration support.",
//   },
//   {
//     step: "5",
//     title: "Support & Growth",
//     desc: "Continuous upgrades, monitoring, and scaling.",
//   },
// ];

// const testimonials = [
//   {
//     name: "Amit Kumar",
//     role: "Director, Global Logistics",
//     feedback:
//       "Quadrangle Solutions transformed our logistics ERP. Our efficiency improved drastically and customer satisfaction doubled.",
//     avatar: "https://dummyimage.com/100x100/22c55e/000.png&text=A",
//   },
//   {
//     name: "Sarah Johnson",
//     role: "CFO, Retail Group",
//     feedback:
//       "Their finance automation system reduced manual work by 60%. Reports are real-time and compliance-ready.",
//     avatar: "https://dummyimage.com/100x100/16a34a/000.png&text=S",
//   },
// ];

// const techStack = [
//   "React",
//   "Node.js",
//   "MongoDB",
//   "AWS",
//   "Docker",
//   "Kubernetes",
// ];

// const faqs = [
//   {
//     q: "Do you provide custom ERP systems?",
//     a: "Yes. Every ERP we build is tailored to your business model and workflows.",
//   },
//   {
//     q: "What industries do you focus on?",
//     a: "Shipping, Logistics, Finance, Retail, and Manufacturing are our key verticals.",
//   },
//   {
//     q: "Do you offer ongoing support?",
//     a: "Yes. We provide long-term maintenance, upgrades, and scaling support.",
//   },
// ];

// // Animation
// const fadeInUp = {
//   hidden: { opacity: 0, y: 30 },
//   visible: { opacity: 1, y: 0 },
// };

// const DataBuildServices = () => {
//   return (
//     <div className="bg-black text-green-400 font-sans">
//       {/* Hero */}
//       <section className="text-center py-28 px-6">
//         <motion.h1
//           initial="hidden"
//           animate="visible"
//           variants={fadeInUp}
//           className="text-6xl md:text-7xl font-extrabold mb-6 bg-gradient-to-r from-green-400 to-green-600 text-transparent bg-clip-text"
//         >
//           Smart Digital Transformation
//         </motion.h1>
//         <motion.p
//           variants={fadeInUp}
//           className="text-xl max-w-4xl mx-auto text-green-300"
//         >
//           Empowering{" "}
//           <span className="text-green-500 font-semibold">Shipping</span>,{" "}
//           <span className="text-green-500 font-semibold">Logistics</span>,{" "}
//           <span className="text-green-500 font-semibold">Retail</span>, and{" "}
//           <span className="text-green-500 font-semibold">Finance</span> with
//           automation, ERP, and compliance-ready software.
//         </motion.p>
//       </section>

//       {/* Services */}
//       <section className="px-6 py-20 max-w-7xl mx-auto grid md:grid-cols-2 gap-12">
//         {services.map((service, i) => (
//           <motion.div
//             key={i}
//             className="bg-gray-900 rounded-2xl overflow-hidden shadow-lg border border-green-600/30 hover:border-green-500 transition"
//           >
//             <img
//               src={service.illustration}
//               alt={service.title}
//               className="w-full h-48 object-cover"
//             />
//             <div className="p-6">
//               <h3 className="text-2xl font-bold mb-3">
//                 {service.icon} {service.title}
//               </h3>
//               <p className="mb-4 text-green-300">{service.description}</p>
//               <ul className="space-y-2 mb-6">
//                 {service.features.map((f, j) => (
//                   <li key={j} className="flex items-start">
//                     ✔ {f}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </motion.div>
//         ))}
//       </section>

//       {/* Industries */}
//       <section className="py-20 bg-gray-900 text-center">
//         <h2 className="text-4xl font-bold mb-12">Industries We Serve</h2>
//         <div className="grid md:grid-cols-4 gap-8 max-w-6xl mx-auto">
//           {industries.map((ind, i) => (
//             <div
//               key={i}
//               className="p-6 bg-black rounded-xl shadow hover:scale-105 transition"
//             >
//               <div className="text-5xl mb-4">{ind.icon}</div>
//               <h3 className="text-xl font-semibold">{ind.name}</h3>
//               <p className="text-green-300 mt-2">{ind.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Why Choose Us */}
//       <section className="py-20 text-center px-6">
//         <h2 className="text-4xl font-bold mb-12">Why Choose Us</h2>
//         <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
//           {whyChoose.map((item, i) => (
//             <div
//               key={i}
//               className="p-6 bg-gray-900 rounded-xl shadow hover:border-green-500 border border-transparent transition"
//             >
//               <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
//               <p className="text-green-300">{item.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Process */}
//       <section className="py-20 bg-gray-900 text-center px-6">
//         <h2 className="text-4xl font-bold mb-12">Our Process</h2>
//         <div className="grid md:grid-cols-5 gap-6 max-w-7xl mx-auto">
//           {processSteps.map((step, i) => (
//             <div key={i} className="p-6 bg-black rounded-xl shadow">
//               <div className="text-3xl font-bold text-green-500 mb-2">
//                 {step.step}
//               </div>
//               <h3 className="text-lg font-semibold">{step.title}</h3>
//               <p className="text-green-300 mt-2">{step.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Testimonials */}
//       <section className="py-20 text-center">
//         <h2 className="text-4xl font-bold mb-12">What Our Clients Say</h2>
//         <Swiper
//           modules={[Autoplay, Pagination]}
//           autoplay={{ delay: 4000 }}
//           pagination={{ clickable: true }}
//           spaceBetween={30}
//           slidesPerView={1}
//           className="max-w-3xl mx-auto"
//         >
//           {testimonials.map((t, i) => (
//             <SwiperSlide key={i}>
//               <div className="p-8 bg-gray-900 rounded-2xl shadow text-green-300">
//                 <img
//                   src={t.avatar}
//                   alt={t.name}
//                   className="w-20 h-20 rounded-full mx-auto mb-4"
//                 />
//                 <p className="italic mb-4">"{t.feedback}"</p>
//                 <h3 className="font-semibold text-green-400">{t.name}</h3>
//                 <p className="text-sm">{t.role}</p>
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </section>

//       {/* Tech Stack */}
//       <section className="py-20 bg-gray-900 text-center">
//         <h2 className="text-4xl font-bold mb-12">Our Technology Stack</h2>
//         <div className="flex flex-wrap justify-center gap-6">
//           {techStack.map((tech, i) => (
//             <span
//               key={i}
//               className="px-6 py-3 bg-black rounded-xl shadow border border-green-500"
//             >
//               {tech}
//             </span>
//           ))}
//         </div>
//       </section>

//       {/* FAQ */}
//       <section className="py-20 px-6 text-center">
//         <h2 className="text-4xl font-bold mb-12">Frequently Asked Questions</h2>
//         <div className="max-w-3xl mx-auto space-y-6 text-left">
//           {faqs.map((faq, i) => (
//             <div key={i} className="bg-gray-900 p-6 rounded-xl shadow">
//               <h3 className="text-lg font-semibold">{faq.q}</h3>
//               <p className="text-green-300 mt-2">{faq.a}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Final CTA */}
//       <section className="py-28 text-center">
//         <h2 className="text-4xl font-bold mb-6">
//           Ready to Build Smarter Solutionss?
//         </h2>
//         <p className="text-lg mb-10 text-green-300 max-w-2xl mx-auto">
//           Partner with Quadrangle Solutions for world-class digital Solutionss in
//           logistics, shipping, and enterprise automation.
//         </p>
//         <a
//           href="/contact"
//           className="px-10 py-4 border-2 border-green-500 text-green-500 font-semibold rounded-xl hover:bg-green-500 hover:text-black transition text-lg shadow-lg"
//         >
//           Contact Us
//         </a>
//       </section>
//     </div>
//   );
// };

// export default DataBuildServices;

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

// Dummy illustration URLs
const illustrations = {
  shipping:
    "https://dummyimage.com/400x250/22c55e/ffffff.png&text=Shipping+Automation",
  logistics:
    "https://dummyimage.com/400x250/16a34a/ffffff.png&text=Logistics+ERP",
  retail: "https://dummyimage.com/400x250/15803d/ffffff.png&text=Retail+ERP",
  finance:
    "https://dummyimage.com/400x250/0f766e/ffffff.png&text=Finance+Solutionss",
};

const services = [
  {
    title: "Shipping & Port Automation",
    description:
      "Smart port and vessel management systems that enhance efficiency, transparency, and global trade performance.",
    icon: "⚓",
    illustration: illustrations.shipping,
    features: [
      "Vessel scheduling & berth allocation",
      "Cargo handling automation",
      "Real-time container tracking",
      "Customs & compliance integration",
    ],
  },
  {
    title: "Logistics ERP Development",
    description:
      "Custom ERP platforms built for freight forwarders, logistics companies, and fleet operators.",
    icon: "🚛",
    illustration: illustrations.logistics,
    features: [
      "End-to-end logistics workflows",
      "Warehouse & fleet management",
      "Integrated invoicing & finance",
      "Multi-branch, multi-user systems",
    ],
  },
  {
    title: "Retail & Manufacturing Software",
    description:
      "Automation and ERP systems designed to scale retail chains, manufacturing units, and distribution hubs.",
    icon: "🏭",
    illustration: illustrations.retail,
    features: [
      "Inventory & supply chain visibility",
      "Barcode & RFID integration",
      "Production planning",
      "Demand forecasting",
    ],
  },
  {
    title: "Finance & Compliance Solutionss",
    description:
      "Secure, compliant-ready platforms designed for BFSI, fintech, and regulation-heavy enterprises.",
    icon: "💹",
    illustration: illustrations.finance,
    features: [
      "Automated reporting & auditing",
      "Risk & fraud detection",
      "RBI & DPDP compliance",
      "Multi-currency support",
    ],
  },
];

const industries = [
  {
    name: "Shipping & Logistics",
    icon: "🚢",
    desc: "Digitizing global trade and cargo operations.",
  },
  {
    name: "Retail",
    icon: "🛒",
    desc: "Empowering supply chains and retail networks.",
  },
  {
    name: "Finance",
    icon: "🏦",
    desc: "Building secure & compliant BFSI platforms.",
  },
  {
    name: "Manufacturing",
    icon: "⚙️",
    desc: "Automation-first approach for factories.",
  },
];

const whyChoose = [
  {
    title: "Domain Expertise",
    desc: "Deep industry knowledge in shipping, logistics, and finance.",
  },
  {
    title: "Custom Solutionss",
    desc: "Every system is tailor-made to fit business needs.",
  },
  {
    title: "Cutting-edge Tech",
    desc: "Modern stacks with AI, cloud, and IoT integration.",
  },
  {
    title: "Global Reach",
    desc: "Trusted by enterprises across Asia, Africa, and Europe.",
  },
];

const processSteps = [
  {
    step: "1",
    title: "Consultation",
    desc: "Understanding client challenges and goals.",
  },
  {
    step: "2",
    title: "Design & Strategy",
    desc: "Blueprinting scalable and modern Solutionss.",
  },
  {
    step: "3",
    title: "Development",
    desc: "Agile, iterative, and transparent build process.",
  },
  {
    step: "4",
    title: "Deployment",
    desc: "Seamless integration and migration support.",
  },
  {
    step: "5",
    title: "Support & Growth",
    desc: "Continuous upgrades, monitoring, and scaling.",
  },
];

const testimonials = [
  {
    name: "Amit Kumar",
    role: "Director, Global Logistics",
    feedback:
      "Quadrangle Solutions transformed our logistics ERP. Our efficiency improved drastically and customer satisfaction doubled.",
    avatar: "https://dummyimage.com/100x100/22c55e/ffffff.png&text=A",
  },
  {
    name: "Sarah Johnson",
    role: "CFO, Retail Group",
    feedback:
      "Their finance automation system reduced manual work by 60%. Reports are real-time and compliance-ready.",
    avatar: "https://dummyimage.com/100x100/16a34a/ffffff.png&text=S",
  },
];

const techStack = [
  "React",
  "Node.js",
  "MongoDB",
  "AWS",
  "Docker",
  "Kubernetes",
];

const faqs = [
  {
    q: "Do you provide custom ERP systems?",
    a: "Yes. Every ERP we build is tailored to your business model and workflows.",
  },
  {
    q: "What industries do you focus on?",
    a: "Shipping, Logistics, Finance, Retail, and Manufacturing are our key verticals.",
  },
  {
    q: "Do you offer ongoing support?",
    a: "Yes. We provide long-term maintenance, upgrades, and scaling support.",
  },
];

// Animation
const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const DataBuildServices = () => {
  return (
    <div className="bg-gradient-to-br from-white to-green-50 text-green-900 font-sans">
      {/* Hero */}
      <section className="text-center py-24 px-6 bg-white/80 backdrop-blur-sm rounded-b-3xl">
        <motion.h1
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          className="text-5xl md:text-6xl font-extrabold mb-6 bg-gradient-to-r from-green-600 to-green-800 text-transparent bg-clip-text"
        >
          Smart Digital Transformation
        </motion.h1>
        <motion.p
          variants={fadeInUp}
          className="text-xl max-w-4xl mx-auto text-green-700"
        >
          Empowering{" "}
          <span className="text-green-600 font-semibold">Shipping</span>,{" "}
          <span className="text-green-600 font-semibold">Logistics</span>,{" "}
          <span className="text-green-600 font-semibold">Retail</span>, and{" "}
          <span className="text-green-600 font-semibold">Finance</span> with
          automation, ERP, and compliance-ready software.
        </motion.p>
      </section>

      {/* Services */}
      <section className="px-6 py-16 max-w-7xl mx-auto grid md:grid-cols-2 gap-10">
        {services.map((service, i) => (
          <motion.div
            key={i}
            className="bg-white rounded-2xl overflow-hidden shadow-lg border border-green-300 hover:border-green-500 transition-all duration-300"
          >
            <img
              src={service.illustration}
              alt={service.title}
              className="w-full h-48 object-cover"
            />
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-3 text-green-800">
                {service.icon} {service.title}
              </h3>
              <p className="mb-4 text-green-700">{service.description}</p>
              <ul className="space-y-2 mb-6">
                {service.features.map((f, j) => (
                  <li key={j} className="flex items-start text-green-600">
                    <span className="text-green-500 mr-2">✔</span> {f}
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        ))}
      </section>

      {/* Industries */}
      <section className="py-16 bg-green-50/80 text-center backdrop-blur-sm rounded-3xl my-12">
        <h2 className="text-4xl font-bold mb-12 text-green-800">
          Industries We Serve
        </h2>
        <div className="grid md:grid-cols-4 gap-8 max-w-6xl mx-auto px-6">
          {industries.map((ind, i) => (
            <div
              key={i}
              className="p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-all hover:scale-105"
            >
              <div className="text-5xl mb-4">{ind.icon}</div>
              <h3 className="text-xl font-semibold text-green-800">
                {ind.name}
              </h3>
              <p className="text-green-600 mt-2">{ind.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 text-center px-6 bg-white/80 backdrop-blur-sm rounded-3xl my-12">
        <h2 className="text-4xl font-bold mb-12 text-green-800">
          Why Choose Us
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {whyChoose.map((item, i) => (
            <div
              key={i}
              className="p-6 bg-white rounded-xl shadow-md hover:border-green-400 border border-transparent transition-all"
            >
              <h3 className="text-xl font-semibold mb-2 text-green-800">
                {item.title}
              </h3>
              <p className="text-green-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Process */}
      <section className="py-16 bg-green-50/80 text-center px-6 backdrop-blur-sm rounded-3xl my-12">
        <h2 className="text-4xl font-bold mb-12 text-green-800">Our Process</h2>
        <div className="grid md:grid-cols-5 gap-6 max-w-7xl mx-auto">
          {processSteps.map((step, i) => (
            <div key={i} className="p-6 bg-white rounded-xl shadow-md">
              <div className="text-3xl font-bold text-green-600 mb-2">
                {step.step}
              </div>
              <h3 className="text-lg font-semibold text-green-800">
                {step.title}
              </h3>
              <p className="text-green-600 mt-2">{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 text-center bg-white/80 backdrop-blur-sm rounded-3xl my-12">
        <h2 className="text-4xl font-bold mb-12 text-green-800">
          What Our Clients Say
        </h2>
        <Swiper
          modules={[Autoplay, Pagination]}
          autoplay={{ delay: 4000 }}
          pagination={{
            clickable: true,
            bulletClass: "swiper-pagination-bullet bg-green-300",
            bulletActiveClass: "swiper-pagination-bullet-active !bg-green-600",
          }}
          spaceBetween={30}
          slidesPerView={1}
          className="max-w-3xl mx-auto"
        >
          {testimonials.map((t, i) => (
            <SwiperSlide key={i}>
              <div className="p-8 bg-white rounded-2xl shadow-md text-green-700 border border-green-200">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-20 h-20 rounded-full mx-auto mb-4 border-2 border-green-300"
                />
                <p className="italic mb-4">"{t.feedback}"</p>
                <h3 className="font-semibold text-green-800">{t.name}</h3>
                <p className="text-sm text-green-600">{t.role}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* Tech Stack */}
      <section className="py-16 bg-green-50/80 text-center backdrop-blur-sm rounded-3xl my-12">
        <h2 className="text-4xl font-bold mb-12 text-green-800">
          Our Technology Stack
        </h2>
        <div className="flex flex-wrap justify-center gap-4">
          {techStack.map((tech, i) => (
            <span
              key={i}
              className="px-5 py-2 bg-white rounded-xl shadow-md border border-green-300 text-green-700 font-medium"
            >
              {tech}
            </span>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-6 text-center bg-white/80 backdrop-blur-sm rounded-3xl my-12">
        <h2 className="text-4xl font-bold mb-12 text-green-800">
          Frequently Asked Questions
        </h2>
        <div className="max-w-3xl mx-auto space-y-6 text-left">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-white p-6 rounded-xl shadow-md border border-green-200"
            >
              <h3 className="text-lg font-semibold text-green-800">{faq.q}</h3>
              <p className="text-green-600 mt-2">{faq.a}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 text-center bg-green-100/80 backdrop-blur-sm rounded-3xl my-12">
        <h2 className="text-4xl font-bold mb-6 text-green-800">
          Ready to Build Smarter Solutionss?
        </h2>
        <p className="text-lg mb-10 text-green-700 max-w-2xl mx-auto">
          Partner with Quadrangle Solutions for world-class digital Solutionss
          in logistics, shipping, and enterprise automation.
        </p>
        <a
          href="/contact"
          className="px-10 py-4 bg-green-600 text-white font-semibold rounded-xl hover:bg-green-700 transition-all text-lg shadow-md hover:shadow-lg"
        >
          Contact Us
        </a>
      </section>
    </div>
  );
};

export default DataBuildServices;
